<template>
  <v-dialog
   v-model="$store.state.loadMenu"
  persistent
  fullscreen
  hide-overlay
  content-class="loading-dialog"
  :scrollable="false"
  no-click-animation
  style="overflow: hidden"
  >
    <v-container fill-height class="d-flex align-center justify-center">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        ></v-progress-circular>
        <h3 class="primary--text">Loading Data ...</h3>
      </div>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
    name:"LoadingDialog"

}
</script>

<style>
html {
  overflow-y: scroll;
   scrollbar-gutter: stable;
}
.loading-dialog {
  background: rgba(255, 255, 255, 0.6);
  overflow: hidden !important;
}

/* ป้องกัน body shift */
:deep(.v-dialog__content) {
  width: 100%;
}
</style>